import { useCallback, useEffect, useState } from 'react';

import { getConfigurations } from '../components/trashie/utils/service';
import PAY_ON_SHIP_DEFAULT_CONFIG from '../components/trashie/utils/payOnShip';

const usePayOnShipConfig = ({ enabled = true } = {}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [payOnShipConfig, setPayOnShipConfig] = useState(PAY_ON_SHIP_DEFAULT_CONFIG);

  const loadPayOnShipConfig = useCallback(async () => {
    setIsLoading(true);

    const { value, error } = await getConfigurations('payOnShipConfig');

    if (error) {
      setPayOnShipConfig(PAY_ON_SHIP_DEFAULT_CONFIG);
      setIsLoading(false);
      return;
    }

    const serverConfig = value && typeof value === 'object' && !Array.isArray(value)
      ? value
      : {};

    const merged = { ...PAY_ON_SHIP_DEFAULT_CONFIG, ...serverConfig };

    Object.entries(PAY_ON_SHIP_DEFAULT_CONFIG).forEach(([key, defaultVal]) => {
      if (Array.isArray(defaultVal) && !Array.isArray(merged[key])) {
        merged[key] = defaultVal;
      } else if (typeof defaultVal === 'number' && typeof merged[key] !== 'number') {
        merged[key] = defaultVal;
      }
    });

    setPayOnShipConfig(merged);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (enabled) {
      loadPayOnShipConfig();
    }
  }, [enabled, loadPayOnShipConfig]);

  return {
    isLoading: enabled ? isLoading : false,
    payOnShipConfig,
  };
};

export default usePayOnShipConfig;
